import { DailyParameter } from './daily-parameter.model';
import { AlertParameter } from './alert-parameter.model';

export class Trigger {
  dailyParameter: DailyParameter[];
  parameters: AlertParameter[] = []
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/trigger.model.ts